module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project",
    attrs: {
      "id": _vm.project.alias
    }
  }, [_c('h2', {
    staticClass: "heading"
  }, [(_vm.project.links.website) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.project.links.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.project.title))])]) : _c('span', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('small', {
    staticClass: "side-note",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._l((_vm.project.types), function(type, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'project-type',
          params: {
            alias: type.alias
          }
        }
      }
    }, [_vm._v(_vm._s(type.title))])
  }), _vm._v(" \n    ")], 2)]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.project.description))]), _vm._v(" "), _c('p', {
    staticClass: "status",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('router-link', {
    staticClass: "hover-light",
    attrs: {
      "to": {
        name: 'project-status',
        params: {
          alias: _vm.project.status.alias
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.status.title))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab45c75","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Project.vue
// module id = 918
// module chunks = 1